// removed by extract-text-webpack-plugin
module.exports = {"expanded":"onfido-sdk-ui-EnlargedPreview-expanded","imageContainer":"onfido-sdk-ui-EnlargedPreview-imageContainer","image":"onfido-sdk-ui-EnlargedPreview-image","button":"onfido-sdk-ui-EnlargedPreview-button","entered":"onfido-sdk-ui-EnlargedPreview-entered"};


//////////////////
// WEBPACK FOOTER
// ./components/EnlargedPreview/style.css
// module id = 309
// module chunks = 1